import { useState, useEffect } from 'react'
import { getCategories } from '@services/product.service'
import './FilterSidebar.scss'

export default function FilterSidebar({ filters, setFilter, resetFilters }) {
  const [categories, setCategories] = useState([])
  const [localMin, setLocalMin] = useState(
    filters.minPrice != null ? String(filters.minPrice) : ''
  )
  const [localMax, setLocalMax] = useState(
    filters.maxPrice != null ? String(filters.maxPrice) : ''
  )

  useEffect(() => {
    getCategories()
      .then((res) => setCategories(res?.data ?? []))
      .catch(() => {})
  }, [])

  useEffect(() => {
    setLocalMin(filters.minPrice != null ? String(filters.minPrice) : '')
    setLocalMax(filters.maxPrice != null ? String(filters.maxPrice) : '')
  }, [filters.minPrice, filters.maxPrice])

  const applyMinPrice = () => {
    const n = Number(localMin)
    if (Number.isFinite(n) && n >= 0) setFilter('minPrice', n)
    else if (localMin === '') setFilter('minPrice', undefined)
  }

  const applyMaxPrice = () => {
    const n = Number(localMax)
    if (Number.isFinite(n) && n >= 0) setFilter('maxPrice', n)
    else if (localMax === '') setFilter('maxPrice', undefined)
  }

  const hasActiveFilters =
    filters.categorySlug ||
    (filters.minPrice != null && filters.minPrice !== '') ||
    (filters.maxPrice != null && filters.maxPrice !== '')

  return (
    <aside className="shop-filters">
      <div className="shop-filters-header">
        <h3 className="shop-filters-title">Filtre</h3>
        {hasActiveFilters && (
          <button
            type="button"
            className="shop-filters-reset"
            onClick={resetFilters}
          >
            Resetează
          </button>
        )}
      </div>

      <div className="shop-filter-block">
        <h4 className="shop-filter-label">Categorie</h4>
        <ul className="shop-filter-categories">
          <li>
            <button
              type="button"
              className={`shop-filter-cat ${!filters.categorySlug ? 'active' : ''}`}
              onClick={() => setFilter('categorySlug', '')}
            >
              Toate
            </button>
          </li>
          {categories.map((cat) => (
            <li key={cat.id}>
              <button
                type="button"
                className={`shop-filter-cat ${filters.categorySlug === cat.slug ? 'active' : ''}`}
                onClick={() => setFilter('categorySlug', cat.slug)}
              >
                {cat.name}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="shop-filter-block">
        <h4 className="shop-filter-label">Preț (lei)</h4>
        <div className="shop-filter-price">
          <input
            type="number"
            min="0"
            step="1"
            placeholder="Min"
            value={localMin}
            onChange={(e) => setLocalMin(e.target.value)}
            onBlur={applyMinPrice}
            onKeyDown={(e) => e.key === 'Enter' && applyMinPrice()}
            className="shop-filter-input"
          />
          <span className="shop-filter-price-sep">–</span>
          <input
            type="number"
            min="0"
            step="1"
            placeholder="Max"
            value={localMax}
            onChange={(e) => setLocalMax(e.target.value)}
            onBlur={applyMaxPrice}
            onKeyDown={(e) => e.key === 'Enter' && applyMaxPrice()}
            className="shop-filter-input"
          />
        </div>
      </div>

      {hasActiveFilters && (
        <div className="shop-filter-pills">
          {filters.categorySlug && (
            <span className="shop-pill">
              {categories.find((c) => c.slug === filters.categorySlug)?.name ?? filters.categorySlug}
              <button
                type="button"
                className="shop-pill-remove"
                onClick={() => setFilter('categorySlug', '')}
                aria-label="Elimină filtru"
              >
                ×
              </button>
            </span>
          )}
          {filters.minPrice != null && (
            <span className="shop-pill">
              Min {filters.minPrice} lei
              <button
                type="button"
                className="shop-pill-remove"
                onClick={() => {
                  setFilter('minPrice', undefined)
                  setLocalMin('')
                }}
                aria-label="Elimină filtru"
              >
                ×
              </button>
            </span>
          )}
          {filters.maxPrice != null && (
            <span className="shop-pill">
              Max {filters.maxPrice} lei
              <button
                type="button"
                className="shop-pill-remove"
                onClick={() => {
                  setFilter('maxPrice', undefined)
                  setLocalMax('')
                }}
                aria-label="Elimină filtru"
              >
                ×
              </button>
            </span>
          )}
        </div>
      )}
    </aside>
  )
}
